import { Info } from 'lucide-react' // Revert to lucide-react icon
import type React from 'react'
import { useId, useState } from 'react' // Import useId
import { Button } from '@/components/ui/button'
import { Checkbox } from '@/components/ui/checkbox'
import type { DisclaimerModalProps } from '@/types/components'
import { useLanguage } from '../contexts/LanguageContext'

const DisclaimerModal: React.FC<DisclaimerModalProps> = ({ isOpen, onAcknowledge }) => {
  const [isChecked, setIsChecked] = useState(false)
  const { t } = useLanguage()
  const disclaimerCheckboxId = useId() // Generate a unique ID

  if (!isOpen) {
    return null
  }

  const handleAcknowledge = () => {
    if (isChecked) {
      onAcknowledge()
    }
  }

  return (
    <>
      <div className="fixed inset-0 z-40 bg-black/60 backdrop-blur-sm" />
      <div className="fixed bottom-0 left-0 right-0 z-50 flex justify-center">
        <div className="m-4 w-full max-w-3xl transform rounded-lg bg-white p-6 text-left align-middle shadow-xl transition-all">
          <div className="flex items-center gap-x-3">
            <div className="flex h-8 w-8 items-center justify-center rounded-md bg-primary">
              <Info className="h-5 w-5 text-white" aria-hidden="true" />
            </div>
            <h3 className="text-lg font-medium leading-6 text-gray-900">
              {t('disclaimer_modal.title', 'Notice')}
            </h3>
          </div>
          <div className="mt-4">
            <p className="text-sm text-gray-600">
              {t(
                'disclaimer_modal.main_text',
                'While every effort is made to ensure the accuracy of the information contained in this website, Sheet Pile LLC cannot guarantee its completeness or correctness.  For specific inquiries, please contact the relevant manufacturer.',
              )}
            </p>
          </div>

          <div className="mt-6 flex items-start space-x-3">
            <Checkbox
              id={disclaimerCheckboxId} // Use the generated ID
              checked={isChecked}
              onCheckedChange={() => setIsChecked(!isChecked)}
              className="mt-1"
            />
            <label
              htmlFor={disclaimerCheckboxId} // Use the generated ID
              className="text-sm font-medium leading-none text-gray-700 peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              {t(
                'disclaimer_modal.checkbox_label',
                'I acknowledge and agree that Sheet Pile LLC shall bear no responsibility or liability of any kind arising from the content of this site or the use of its information.',
              )}
            </label>
          </div>

          <div className="mt-6 flex justify-end">
            <Button onClick={handleAcknowledge} disabled={!isChecked}>
              {t('disclaimer_modal.button_text', 'Acknowledge and Continue')}
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}

export default DisclaimerModal
